import { useEffect, useState } from 'react'
import { useParams, useNavigate } from "react-router-dom"
import { catalan_calendar } from '../../utils/editDatePicker'
import { LocalStorage } from '../../services/localStorage/LocalStorage.services'

import Select from 'react-select'
import DatePicker from "react-multi-date-picker"
import Modal from '../../components/Modal/Modal'

import getTaskById from '../../services/tasks/getTaskById'
import getAllProfessionals from '../../services/professionals/getAllProfessionals'
import getAllLabels from '../../services/labels/getAllLabels'
import getAllTipus from '../../services/tipus/getAllTipus'
import getAllArees from '../../services/arees/getAllArees'
import postTask from '../../services/tasks/postTask'
import putTask from '../../services/tasks/putTask'

import styles from './NewTask.module.css'

const NewTask = () => {
    
    let navigate = useNavigate()

    const { id } = useParams()
    const [ newTask, setNewTask ] = useState({})
    const [ active, setActive ] = useState(true)
    const [ professionals, setProfessionals ] = useState([])
    const [ labels, setLabels ] = useState([])
    const [ tipus, setTipus ] = useState([])
    const [ arees, setArees ] = useState([])
    const [ error, setError ] = useState("")
    const [ disable, setDisable ] = useState(true)
    const [ otherProfessionals, setOtherProfessionals ] = useState([])
    const [ labelsOptions, setLabelOptions ] = useState([])
    const [ valueInitialData, setValuesInitialData ] = useState(null)
    const [ valueFinalData, setValuesFinalData ] = useState(null)

    useEffect(() => {
        getAllProfessionals()
        .then(professionals => {
            setProfessionals(professionals)
            getAllLabels()
            .then(labels => {
                setLabels(labels)
                if (id !== undefined) {
                    getTaskById(id)
                    .then(task => {
                        setNewTask(task)
                        setActive(task.taskActive)
                        let dateInitial = new Date(task.taskPlanningDate)
                        setValuesInitialData(dateInitial)
                        if (task.taskDoDate) {
                            let dateFinal = new Date(task.taskDoDate)
                            setValuesFinalData(dateFinal)
                        }
                        setOtherProfessionals(task.taskOtherProfessionalId && task.taskOtherProfessionalId.map(professional => {
                            const professionalFilter = professionals.find(element => element._id === professional._id)    
                            return ({ value: professional, label: `${professionalFilter.professionalName} ${professionalFilter.professionalLastName1} ${professionalFilter.professionalLastName2}` })
                        }))
                        setLabelOptions(task.taskLabelId && task.taskLabelId.map(etiqueta => {
                            const labelFilter = labels && labels.find(element => element._id === etiqueta._id)   
                            return ({ value: etiqueta, label: `${labelFilter.labelName}` })
                        }))
                    })
                }
            })
            })
        getAllTipus()
        .then(tipus => {
            setTipus(tipus)
        })
        getAllArees()
        .then(arees => {
            setArees(arees)
        })

    },[id])

    const handleSubmit = (event) => {
        event.preventDefault()
        let form = event.target
        let formData = new FormData(form)
        formData.append('taskStatus', event.target.taskStatus.checked)
        formData.append('taskCompanyId', LocalStorage.getItem("professionalCompany"))
        formData.append('taskServeiId', LocalStorage.getItem("professionalServei"))
        let formJson = Object.fromEntries(formData.entries())
        const professionalArray = otherProfessionals.map(option => option.value)
        formJson.taskOtherProfessionalId = professionalArray
        const labelsArray = labelsOptions.map(option => option.value)
        formJson.taskLabelId = labelsArray
        if (id !== undefined) {
            let dateUnixInitial = new Date(valueInitialData).toISOString()
            formJson.taskPlanningDate = dateUnixInitial
            if (valueFinalData !== null) {
                let dateUnixFinal = new Date(valueFinalData).toISOString()
                formJson.taskDoDate = dateUnixFinal
            }
            putTask(formJson, id) 
            .then(newTask => {
                setNewTask(newTask)
            })
        } else {
            let dateUnixInitial = new Date(valueInitialData).toISOString()
            formJson.taskPlanningDate = dateUnixInitial
            postTask(formJson) 
            .then(newTask => {
                setNewTask(newTask)
            })
        }
        setDisable(false)
        setTimeout(() => {
            setDisable(true)
            navigate("/tasques/daily", { replace: true })
        },3000)
    }

    const handleChange = (event) => {
        if (event.target.id === "taskStatus") {
            setActive(event.target.checked)
        } else {
            setNewTask(event.target.value)
        }
    }

    const handleChangeOtherProfessionals = (selectedOptions) => {
        setOtherProfessionals(selectedOptions)
    }

    const otherProfessionalsOptions = professionals.map(element => ({
        value: element._id,
        label: `${element.professionalName} ${element.professionalLastName1} ${element.professionalLastName2}` 
    }))

    const handleChangeEtiquetes = (selectedOptions) => {
        setLabelOptions(selectedOptions)
    }

    const etiquetesOptions = labels.map(element => ({
        value: element._id,
        label: `${element.labelName}` 
    }))

    return (
        <div className={styles.container}>
            <h2>{id ? "Editar tasca" : "Alta nova tasca"}</h2>
            <div className={`${styles.modal} ${disable && styles.disable}`}>
            <Modal error={error} id={id} text={id ? "Tasca modificada correctament" : "Tasca creada correctament"}></Modal>
            </div>
            <form onSubmit={handleSubmit}>
                <label for="taskDescription">Tasca</label>
                <input onChange={handleChange} type="text" name="taskDescription" value={newTask.taskDescription && newTask.taskDescription} required/>
                <label>Planificada</label>
                <DatePicker   
                    style={{
                        width: "100%",
                        boxSizing: "border-box",
                        height: "100%",
                        padding: "0.5em",
                        backgroundColor: "aliceblue",
                        borderRadius: ".3rem",
                        border: "none",
                    }}
                    containerStyle={{
                        width: "100%"
                    }}
                    calendarPosition="bottom-center" 
                    locale={catalan_calendar}
                    displayWeekNumbers="enable"
                    numberOfMonths={3}
                    weekStartDayIndex={1}
                    value={valueInitialData} 
                    format="DD/MM/YYYY"
                    onChange={setValuesInitialData} 
                />
                {
                    id &&
                    <>
                        <label>Realitzada</label>
                        <DatePicker   
                            style={{
                                width: "100%",
                                boxSizing: "border-box",
                                height: "100%",
                                padding: "0.5em",
                                backgroundColor: "aliceblue",
                                borderRadius: ".3rem",
                                border: "none",
                            }}
                            containerStyle={{
                                width: "100%"
                            }}
                            calendarPosition="bottom-center" 
                            locale={catalan_calendar}
                            displayWeekNumbers="enable"
                            numberOfMonths={3}
                            weekStartDayIndex={1}
                            value={valueFinalData} 
                            format="DD/MM/YYYY"
                            onChange={setValuesFinalData} 
                        />
                    </>
                }
                <label for="taskProfessionalId">Responsable</label>
                <select onChange={handleChange} name="taskProfessionalId" value={!id ? LocalStorage.getItem('id') : newTask.taskProfessionalId && newTask.taskProfessionalId._id} required>
                    {
                        professionals && professionals.map( element => {
                            return (
                                <option value={element._id}>{element.professionalName} {element.professionalLastName1} {element.professionalLastName2}</option>
                            )
                        })
                    }
                </select>
                <label for="taskOtherProfessionalId">Altres responsables</label>
                <Select
                    name="taskOtherProfessionalId"
                    value={otherProfessionals}
                    onChange={handleChangeOtherProfessionals}
                    options={otherProfessionalsOptions}
                    isMulti
                    placeholder="- Selecciona -"
                />
                <label for="taskAreaId">Àrea</label>
                <select onChange={handleChange} name="taskAreaId" value={newTask.taskAreaId && newTask.taskAreaId._id}>
                    {
                        arees && arees.map( element => {
                            return (
                                <option value={element._id}>{element.areaName}</option>
                            )
                        })
                    }
                </select>
                <label for="taskTypeId">Tipus de tasca</label>
                <select onChange={handleChange} name="taskTypeId" value={newTask.taskTypeId && newTask.taskTypeId._id}>
                    {
                        tipus && tipus.map( element => {
                            return (
                                <option value={element._id}>{element.typeName}</option>
                            )
                        })
                    }
                </select>
                <label for="taskLabelId">Etiquetes</label>
                <Select
                    name="taskLabelId"
                    value={labelsOptions}
                    onChange={handleChangeEtiquetes}
                    options={etiquetesOptions}
                    isMulti
                    placeholder="- Selecciona -"
                />
                <label for="taskStatus">Oberta</label>
                <input type='checkbox' onChange={handleChange} name="taskStatus" id="taskStatus" checked={active} className={styles.checking} />
                <div className={styles.btn_container}>
                    <button className={ styles.btn_add} type='submit'>{id ? <span>Guardar</span> : <span>Crear</span>}</button>
                </div>
            </form>
        </div>
    )
} 

export default NewTask